import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import PortfolioSettingsFormContainer from '../../containers/portfolio/PortfolioSettingsFormContainer.jsx';

const PortfolioSettings = ({ portfolioId, slug }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('portfolio')} Settings | ChangeSync</title>
    </Helmet>
    <PortfolioSettingsFormContainer portfolioId={portfolioId} slug={slug} />
  </>
);

PortfolioSettings.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(PortfolioSettings));
